export const createRequestBody = values => {
    const cardPan = values.cardPan;
    const expiryYear = values.expiryDate && (values.expiryDate.getFullYear()).toString();
    const expiryMonth = values.expiryDate && (values.expiryDate.getMonth() + 1).toString()
    const requestParams = {
      issuerNumber: values.issuerNumber && values.issuerNumber.issuerNr ? values.issuerNumber.issuerNr : '',
      sequenceNumber: values.sequenceNumber,
      expiryDate: values.expiryDate ? `${expiryYear.substring(2,4)}${expiryMonth.length > 1 ? expiryMonth : ('0' + expiryMonth)}` : '',
      startDate: values.startDate
        ? `${("0" + values.startDate.getDate()).slice(-2)}/${(
            "0" +
            (values.startDate.getMonth() + 1)
          ).slice(-2)}/${values.startDate.getFullYear()}`
        : "",
      endDate: values.endDate
        ? `${("0" + values.endDate.getDate()).slice(-2)}/${(
            "0" +
            (values.endDate.getMonth() + 1)
          ).slice(-2)}/${values.endDate.getFullYear()}`
        : ""
    };
    if (values.download) {
      requestParams["download"] = true;
    }
    return {
      cardPan,
      requestParams
    };
  };